export function isAutoQueueDirty(savedIds: readonly string[], draftIds: readonly string[]): boolean {
	if (savedIds.length !== draftIds.length) return true;
	return savedIds.some((id, index) => id !== draftIds[index]);
}

/** Empty saved queue must not call start. */
export function canStartAutoCampaign(savedIds: readonly string[]): boolean {
	return savedIds.length > 0;
}

export function toggleAutoPreset(order: readonly string[], id: string, on: boolean): string[] {
	if (on) {
		if (order.includes(id)) return [...order];
		return [...order, id];
	}
	return order.filter(item => item !== id);
}

export function moveAutoPreset(order: readonly string[], id: string, direction: -1 | 1): string[] {
	const index = order.indexOf(id);
	if (index < 0) return [...order];
	const next = index + direction;
	if (next < 0 || next >= order.length) return [...order];
	const copy = [...order];
	const [item] = copy.splice(index, 1);
	if (!item) return [...order];
	copy.splice(next, 0, item);
	return copy;
}
